export default "__VITE_ASSET__qs4e8DZw__"